// src/components/ProgressTracker.js
import React from "react";
import { motion } from "framer-motion";

const steps = ["Legal", "Phone", "Address", "Documents", "Services", "Review"];

const ProgressTracker = ({ currentStep }) => {
  const progressPercent = ((currentStep + 1) / steps.length) * 100;

  return (
    <div className="w-full mb-6 select-none">
      {/* Progress Bar */}
      <div className="relative w-full h-2 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden">
        <motion.div
          className="h-full bg-gradient-to-r from-indigo-600 to-blue-500 rounded-full"
          initial={{ width: 0 }}
          animate={{ width: `${progressPercent}%` }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
        />
      </div>

      {/* Step Labels */}
      <div className="flex justify-between text-xs mt-2 font-medium">
        {steps.map((step, index) => (
          <div
            key={index}
            className={`flex-1 text-center transition-colors duration-300 ${
              index === currentStep
                ? "text-indigo-600 dark:text-indigo-400 font-semibold"
                : "text-gray-600 dark:text-gray-300"
            }`}
          >
            {step}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProgressTracker;
